const schema = () => ({
  title: 'Réserver par téléphone',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'description'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Réserver',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: "Une table, un dîner, un déjeuner d'affaires.",
    },
    description: {
      title: 'Description',
      type: 'string',
      default:
        'Composez l’un des deux numéros — nous vous proposons une table à votre convenance.',
    },
  },
  required: [],
});

export default schema;
